import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  memberStack: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    '& > *': {
      width: '23%',
      justifyContent: 'flex-start',
    },
  },
  addIcon: {
    alignItems: 'center',
    border: '1px dashed #6d6e6f',
    borderRadius: '50%',
    display: 'flex',
    fill: '#6d6e6f',
    flexGrow: 0,
    flexShrink: 0,
    justifyContent: 'center',
    height: '33px',
    width: '33px',
    marginRight: theme.spacing(1),
  },
  avatarContainer: {
    position: 'relative',
  },
  memberButton: {
    borderRadius: '8px',
    border: '1px solid #d8dde1',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(1),
  },
  avatarIcon: {
    height: '33px',
    width: '33px',
    marginRight: theme.spacing(1),
    fontSize: 'medium',
  },
  memberTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  },
  roleText: {
    fontSize: 'x-small',
    textAlign: 'left',
  },
  circularProgress: {
    position: 'absolute',
    top: -2.1,
    left: -2.3,
    zIndex: 1,
    width: '38px !important',
    height: '38px !important',
  },
  statusBadgeWrapper: {
    marginLeft: 'auto',
    marginRight: theme.spacing(1),
  },
  badge: {
    width: 12,
    height: 12,
    borderRadius: '50%',
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
  },
  activeBadge: {
    backgroundColor: theme.palette.success.main,
  },
  inactiveBadge: {
    backgroundColor: theme.palette.grey[500],
  },
}));
